var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 549,
    height: 85,
    viewBox: "0 0 549 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4 0V16.2388H63V0H-4ZM-4 34.5438V50.7826H63V34.5438H-4ZM-4 69.0874V85H63V69.0874H-4Z",
    fill: "url(#paint0_linear_2_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4801 -1.54546H90.9886L120.401 70.294H121.415L150.827 -1.54546H163.335V85H153.531V19.2457H152.686L125.641 85H116.175L89.1293 19.2457H88.2841V85H78.4801V-1.54546ZM187.898 85H176.911L208.689 -1.54546H219.507L251.286 85H240.299L214.436 12.1463H213.76L187.898 85ZM191.955 51.1932H236.242V60.4901H191.955V51.1932ZM264.766 85V-1.54546H294.009C300.771 -1.54546 306.32 -0.390391 310.659 1.91974C314.998 4.2017 318.209 7.34292 320.294 11.3434C322.379 15.3439 323.421 19.8937 323.421 24.9929C323.421 30.0921 322.379 34.6138 320.294 38.5579C318.209 42.502 315.012 45.601 310.701 47.8548C306.391 50.0804 300.883 51.1932 294.178 51.1932H270.513V41.7273H293.84C298.46 41.7273 302.179 41.0511 304.996 39.6989C307.842 38.3466 309.898 36.4309 311.166 33.9517C312.462 31.4444 313.11 28.4581 313.11 24.9929C313.11 21.5277 312.462 18.4992 311.166 15.9073C309.87 13.3155 307.8 11.3152 304.954 9.9066C302.109 8.46981 298.348 7.75142 293.671 7.75142H275.246V85H264.766ZM305.503 46.1222L326.802 85H314.631L293.671 46.1222H305.503ZM340.884 85V-1.54546H351.365V41.3892H352.379L391.257 -1.54546H404.948L368.606 37.5014L404.948 85H392.271L362.183 44.7699L351.365 56.9403V85H340.884ZM418.513 85V-1.54546H470.745V7.75142H428.993V36.9943H468.04V46.2912H428.993V75.7031H471.421V85H418.513ZM484.901 7.75142V-1.54546H549.811V7.75142H522.596V85H512.116V7.75142H484.901Z",
    fill: "#1E3225"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2",
    x1: 294.868,
    y1: 0.0000014787,
    x2: 288.849,
    y2: 140.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76BA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9A2A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 157,
    fill: "white",
    transform: "translate(0 -14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.554a49d6992d4499da08cc18db69f327.svg";
export { ForwardRef as ReactComponent };